import * as React from 'react';
import { useIntl } from 'react-intl';

import { Layout } from '@components/layout';
import { Header } from '@components/header';
import { ArtistsView } from '@components/artistsView';
import { HEADER_TOP } from '@components/header/header.constants';
import { LayoutSwitcher } from '@components/PLP/layoutSwitcher';
import { MenuContainer, MenuOption } from '@components/PLP/artistView/artistView.styles';
import api from '@services/api';
import { Artist } from '@definitions/artists.types';
import { useChangeLayoutVariant } from '@hooks/useArtists';
import reportError from '@utils/reportError';
import { redirectOnError } from '@utils/helpers';

export const getServerSideProps = async () => {
  try {
    const {
      data: { items: artists },
    } = await api.get('/artists/');

    if (!artists) {
      return { notFound: true };
    }

    return {
      props: { artists },
    };
  } catch (e) {
    reportError(e);

    return redirectOnError(e);
  }
};

interface SlugProps {
  artists: Artist[];
}

const Slug = ({ artists }: SlugProps) => {
  const { layoutVariant } = useChangeLayoutVariant();
  const intl = useIntl();
  const headerTitle = intl.formatMessage({
    id: 'artists.headerTitle',
    defaultMessage: 'Contemporary Artists | Emerging Artists',
  });
  const headerDescription = intl.formatMessage({
    id: 'artists.headerDescription',
    defaultMessage: 'Discover the artists to know now on Platform, the online destination for art.',
  });

  const renderCustomHeader = () => (
    <Header headerTop={HEADER_TOP.REGULAR}>
      <MenuContainer>
        <MenuOption>
          <LayoutSwitcher />
        </MenuOption>
      </MenuContainer>
    </Header>
  );

  return (
    <Layout title={headerTitle} defaultDescription={headerDescription}>
      <ArtistsView artists={artists} layoutVariant={layoutVariant} />
    </Layout>
  );
};

export default Slug;
